<template>
    <div class="pb-20px pb-0!">
        <div class="color-#fff text-center text-16px font-900 pb-20px pb-0">
            Set chat background
        </div>
        <div class="flex flex-wrap gap-5px check-bg max-h-500px overflow-y-auto"
            v-if="backgroundStore.backgroundList.length > 0">
            <div :class="{ 'selected': getSelectedIndex(item.thumbUrl, index) }"
                class="rounded-10px overflow-hidden w-105px h-158px mt-10px relative"
                v-for="(item, index) in backgroundStore.backgroundList" @click="handleAlbum(item, index)">
                <AppImage :src="item.url" alt="avatar" width="100%" height="100%" :show-loading="true"
                    :show-error="true" :lazy-load="false" :custom-loading="true" :custom-error="true"
                    fallback="@/assets/images/home/sitemap.webp" fit="cover"
                    @error="() => console.log('Image error:', item.url)" />
                <div class="w-full h-full  locked-overlay" v-if="!item.isUnlock"
                    @click.stop="handlePreviewImages(item, index)">
                    <img src="@/assets/images/other/lock.svg" alt=""
                        class="w-13px h-13px absolute top-50% left-50% transform -translate-x-1/2 -translate-y-1/2">
                </div>
                <div class="select" @click="handleCheckBg(item)" v-if="getSelectedIndex(item.thumbUrl, index)">
                    Selected
                </div>
                <div v-if="item.isUnlock" class="unfold w-16px h-16px" @click.stop="handlePreviewImages(item, index)">
                    <img src="@/assets/images/message/unfold.svg " class="w-full h-full"></img>
                </div>
            </div>
        </div>
        <div class="py-40px flex items-center justify-center" v-else>
            <van-loading type="spinner" color="#fff" size="24px" />
        </div>
        <!-- 全屏图片预览 -->
        <FullscreenImagePreview v-model:show="showImagePreview" :images="previewImages" :infoItem="infoItem"
            :start-position="previewStartPosition" :isShowSetAsBackdrop="isShowSetAsBackdrop"
            @unlockSuccess="handleUnlockSuccess" @checkBg="handleCheckBg(infoItem)"
            :numberChatMessages="numberChatMessages" :numberChatMessagesTotal="info?.levelExpOrigin" />
    </div>
</template>
<script setup lang="ts">
import AppImage from '@/components/display/AppImage.vue'
import { FullscreenImagePreview } from '@/components/feedback'
import { ref, onMounted, watch } from 'vue'
import { useBackgroundStore } from '@/stores/background'

const props = defineProps<{
    id: any
    info: any
    checkSetBg: (id: any, item: any) => void
    background: string
}>()
const backgroundStore = useBackgroundStore()
const roleAlbum = ref()
// 本地选中态：用于初始化显示和点击即时高亮
const selectedId = ref<any>(null)
// 全屏预览状态
const showImagePreview = ref(false)
const previewImages = ref<string[]>([])
const previewStartPosition = ref(0)
const infoItem = ref()
const active = ref(0)
const isShowSetAsBackdrop = ref()
const numberChatMessages = ref(0)

const getSelectedIndex = (url: string, index: number) => {
    const item = roleAlbum.value?.[index]
    if (selectedId.value != null && item) {
        return item.id === selectedId.value
    }
    // 初始时根据当前背景匹配
    return cutBackground(url) === cutBackground(props.background)
}

/**
 * 获取角色相册
 */
const getRoleAlbum = async () => {
    roleAlbum.value = backgroundStore.backgroundList
    // 根据当前背景初始化选中项
    initSelectedFromBackground()
}
watch(backgroundStore.backgroundList, () => {
    getRoleAlbum()
})
/**
 * 设置背景
*/
const handleAlbum = async (item: any, index: any) => {
    if (getSelectedIndex(item.thumbUrl, index)) {
        return
    }
    infoItem.value = item
    active.value = index

    // 立即本地标记选中
    selectedId.value = item?.id
    props.checkSetBg(item.id, item)
    setTimeout(() => {
        showImagePreview.value = false
    }, 500)
    // 已解锁：点击即选中并高亮
    if (item?.isUnlock) {
        selectedId.value = item.id
        return
    }
    // 未解锁：通过遮罩进入预览
}
const handlePreviewImages = (item: any, index: number) => {

    infoItem.value = item
    numberChatMessages.value = index

    isShowSetAsBackdrop.value = !item.isUnlock

    // 构建图片数组，可以包含多张图片
    const images = []

    // 添加背景图片
    if (item.url) {
        images.push(item.url)
    }

    previewImages.value = images
    showImagePreview.value = true

}
const handleCheckBg = (item: any) => {
    props.checkSetBg(item.id, item)
    setTimeout(() => {
        showImagePreview.value = false
    }, 1500)
}

/**
 * 处理解锁成功
 */
const handleUnlockSuccess = async (imageId: number) => {

    // 更新本地相册数据，将解锁的图片标记为已解锁
    if (roleAlbum.value) {
        const unlockedItem = roleAlbum.value.find((item: any) => item.id === imageId)
        if (unlockedItem) {
            unlockedItem.isUnlock = true
            unlockedItem.typeSee = 1 // 假设 1 表示已解锁
        }
    }

    // 隐藏解锁遮罩
    isShowSetAsBackdrop.value = false




    // 重新获取相册数据（可选，确保数据同步）
    await backgroundStore.getBackgroundList(props.id)
}

/**
 * 切割数据
*/

const cutBackground = (url: string) => {
    const parts = url.split('/');
    const filename = parts[parts.length - 1]; // "1758203836137490171_Cc571erK.png"
    const basename = filename.replace(/\.[^/.]+$/, ""); // "1758203836137490171_Cc571erK"
    return basename
}

// 初始化/同步：根据 background 在相册里定位已选项
const initSelectedFromBackground = () => {
    if (!roleAlbum.value || !Array.isArray(roleAlbum.value)) return
    const found = roleAlbum.value.find((it: any) => (
        cutBackground(it?.thumbUrl || it?.url || '') === cutBackground(props.background)
    ))
    if (found) selectedId.value = found.id
}

watch(() => props.background, () => {
    // 背景变更时同步本地选中
    initSelectedFromBackground()
})
watch(roleAlbum, () => {
    // 数据到达时尝试初始化
    initSelectedFromBackground()
})

onMounted(() => {
    getRoleAlbum()
})
</script>
<style scoped lang="scss">
.check-bg {
    .item {
        border: 2px solid transparent;
        overflow: hidden;
        border-radius: 10px;
        position: relative;
    }

}

.unfold {
    position: absolute;
    top: 0px;
    right: 5px;
}

.locked-overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 10px;
    background: rgba(1, 3, 27, 0.5);
    // border-radius: 10px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    overflow: hidden;
}

.select {
    position: absolute;
    font-size: 10px;
    color: #7284F7;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 15px;
    bottom: 8px;
    left: 50%;
    transform: translate(-50%);
    padding: 3px 10px;
}

.selected {
    border: 2px solid #7284F7;
}

.locked-overlay-img {
    object-fit: cover;
    object-position: top;

    /* 或者 cover */
}

.unfold {
    position: absolute;
    top: 0px;
    right: 5px;
}
</style>